import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * RefCapture — runs on every route change. If the URL has `?ref=CODE`,
 * persist it to localStorage so that whenever the visitor finally signs up
 * (Free or All Access), their referrer gets credited. Cleared on successful
 * signup. 30-day implicit cookie window via localStorage.
 */
export default function RefCapture() {
  const { search } = useLocation();
  useEffect(() => {
    try {
      const params = new URLSearchParams(search);
      const ref = (params.get("ref") || "").trim().toUpperCase();
      if (ref) {
        localStorage.setItem("faitharama_ref", ref);
        localStorage.setItem("faitharama_ref_at", new Date().toISOString());
      }
    } catch {}
  }, [search]);
  return null;
}
